import styled from '@emotion/styled';
import { screenSizes } from 'src/assets/styles/Literals';

export const QuizContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;

  @media (max-width: ${screenSizes.mobile}) {
    gap: 1.5rem;
  }
`;

export const QuizIntro = styled.div`
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border: 1px solid #bae6fd;
  border-radius: 0.75rem;
  padding: 2rem;
  margin-bottom: 1rem;

  p {
    margin: 0 0 1rem 0;
    color: #0c4a6e;
    line-height: 1.7;

    &:last-child {
      margin-bottom: 0;
    }
  }

  h1,
  h2,
  h3 {
    color: #075985;
    margin-top: 0;
  }

  ul,
  ol {
    color: #0c4a6e;
    padding-left: 1.5rem;
  }

  @media (max-width: ${screenSizes.mobile}) {
    padding: 1.5rem;
  }
`;

export const QuizSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  .section-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #1e293b;
    margin: 2rem 0 1rem 0;
    padding-bottom: 0.75rem;
    border-bottom: 2px solid #e2e8f0;

    &:first-child {
      margin-top: 0;
    }

    @media (max-width: ${screenSizes.mobile}) {
      font-size: 1.25rem;
    }
  }

  label {
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 0.75rem;
    display: block;
    font-size: 0.95rem;
    line-height: 1.5;

    &.error {
      color: #dc2626;
    }
  }

  .checkbox {
    margin-bottom: 1.5rem;

    .ui.checkbox {
      margin: 0.5rem 0.75rem 0.5rem 0;

      label {
        font-weight: 500;
        color: #475569;
        font-size: 0.9rem;
      }
    }
  }

  .textArea,
  input[type='text'],
  input[type='number'] {
    margin-bottom: 1.5rem;

    label {
      font-weight: 600;
      color: #1e293b;
      margin-bottom: 0.5rem;
      display: block;
      font-size: 0.95rem;
      line-height: 1.5;

      &.error {
        color: #dc2626;
      }
    }
  }

  .ui.input,
  .ui.form textarea {
    width: 100%;
  }

  .ui.selection.dropdown {
    width: 100%;
    margin-bottom: 1.5rem;
  }

  p {
    color: #64748b;
    line-height: 1.6;
  }

  h2 {
    color: #1e293b;
    margin: 1.5rem 0 1rem 0;
  }

  .richText {
    .intro-text {
      padding: 0;
      margin-bottom: 1rem;
      color: #0c4a6e;
      line-height: 1.7;
      display: block;

      p {
        color: #0c4a6e;

        &:last-child {
          margin-bottom: 0;
        }
      }

      strong {
        color: #075985;
        font-weight: 600;
      }

      ul,
      ol {
        color: #0c4a6e;
        padding-left: 1.5rem;
        margin: 0.5rem 0;
      }

      @media (max-width: ${screenSizes.mobile}) {
        padding: 1.25rem;
      }
    }

    .intro-instructions {
      padding: 0;
      color: #78350f;
      line-height: 1.7;
      display: block;

      p {
        margin: 0 0 0.75rem 0;

        &:last-child {
          margin-bottom: 0;
        }
      }

      strong {
        font-weight: 600;
      }

      ul,
      ol {
        padding-left: 1.5rem;
        margin: 0.5rem 0;
      }

      @media (max-width: ${screenSizes.mobile}) {
        padding: 1.25rem;
      }
    }
  }

  p.intro-text {
    padding: 0;
    margin-bottom: 1rem;
    line-height: 1.7;
  }

  .intro-closing {
    padding: 1.5rem;
    margin-bottom: 2rem;
    font-weight: 600;
    text-align: center;
    font-size: 1.05rem;

    @media (max-width: ${screenSizes.mobile}) {
      padding: 1.25rem;
      font-size: 1rem;
    }
  }

  @media (max-width: ${screenSizes.mobile}) {
    gap: 1rem;
  }
`;
